import { useCallback, useState } from 'react';

export const useRefresh = () => {
  const [key, setKey] = useState<number>(Date.now());

  const refresh = useCallback(() => setKey(Date.now()), []);

  return { key, refresh };
};
